var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9103 1.01121C23.8657 1.76409 22.709 2.33993 21.4849 2.71654C20.8278 1.9447 19.9547 1.39763 18.9834 1.14934C18.0122 0.901042 16.9897 0.963498 16.0544 1.32826C15.119 1.69302 14.3158 2.34249 13.7535 3.18882C13.1912 4.03515 12.8968 5.03751 12.9102 6.06034V7.17494C10.9931 7.22573 9.09343 6.79131 7.3804 5.91037C5.66737 5.02942 4.19416 3.72931 3.09199 2.12581C3.09199 2.12581 -1.27168 12.1572 8.54658 16.6156C6.29986 18.1738 3.62344 18.9551 0.910156 18.8448C10.7284 24.4178 22.7285 18.8448 22.7285 6.0269C22.7275 5.71643 22.6983 5.40673 22.6412 5.10178C23.7546 3.97993 24.5403 2.56352 24.9103 1.01121V1.01121Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwitter);
export default __webpack_public_path__ + "static/media/icon-twitter.c10133036c28d3a07feba15e80ceea7e.svg";
export { ForwardRef as ReactComponent };